import {MouseEventHandler} from 'react';
import ICON_GENRE_LIGHT from '../../../../public/static/v4/bottom-button/icon-genre-light.svg';
import ICON_GENRE from '../../../../public/static/v4/bottom-button/icon-genre.svg';
import ICON_SORT_DOWN_LIGHT from '../../../../public/static/v4/bottom-button/icon-sort-down-light.svg';
import ICON_SORT_DOWN from '../../../../public/static/v4/bottom-button/icon-sort-down.svg';
import ICON_SORT_UP_LIGHT from '../../../../public/static/v4/bottom-button/icon-sort-up-light.svg';
import ICON_SORT_UP from '../../../../public/static/v4/bottom-button/icon-sort-up.svg';
import ICON_TRASH_LIGHT from '../../../../public/static/v4/bottom-button/icon-trash-light.svg';
import ICON_TRASH from '../../../../public/static/v4/bottom-button/icon-trash.svg';
import Button from '../../../common/component/Button';
import Text from '../../../common/component/Text';
import useTheme from '../../../common/hook/useTheme';
import {ITheme} from '../../../common/type';

interface IProps {
  iconVariant?: IBottomButtonVariant;
  disabled?: boolean;
  showShadowBox?: boolean;
  className?: string;
  textClassName?: string;
  onClick?: MouseEventHandler;
  text?: string;
  hasBorder?: boolean;
}

export default function BottomButtonV4({
  iconVariant,
  disabled,
  showShadowBox = true,
  className,
  textClassName,
  onClick,
  text,
  hasBorder = true,
}: IProps) {
  const {theme} = useTheme();
  const src = iconVariant ? ICON_MAP[iconVariant][theme] : undefined;

  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'flex-center gap-x-12 rounded-25',
        'bg-background light:bg-white',
        hasBorder &&
          'border border-solid border-white/10 light:border-black/10',
        showShadowBox && 'shadow-[0px_4px_8px] shadow-black/20',
        className,
        {
          'w-48 h-48': !text,
          'min-w-[48px] h-48 px-24': !!text,
        }
      )}
    >
      {src && <img src={src} alt={iconVariant} className="w-20 h-20" />}
      {text && (
        <Text
          className={cn(
            's14-bold-white light:text-black leading-17',
            textClassName
          )}
        >
          {text}
        </Text>
      )}
    </Button>
  );
}

export type IBottomButtonVariant = 'trash' | 'sort-up' | 'sort-down' | 'genre';

const ICON_MAP: Record<IBottomButtonVariant, Record<ITheme, string>> = {
  trash: {
    dark: ICON_TRASH,
    light: ICON_TRASH_LIGHT,
  },
  'sort-up': {
    dark: ICON_SORT_UP,
    light: ICON_SORT_UP_LIGHT,
  },
  'sort-down': {
    dark: ICON_SORT_DOWN,
    light: ICON_SORT_DOWN_LIGHT,
  },
  genre: {
    dark: ICON_GENRE,
    light: ICON_GENRE_LIGHT,
  },
};
